import React, { CSSProperties, ElementType, FC, HTMLAttributes } from 'react';
import styles from './style.module.css';

export interface RowProps extends HTMLAttributes<HTMLDivElement> {
  as?: ElementType;
  gap?: number;
  gapX?: number;
  gapY?: number;
  alignItems?: CSSProperties['alignItems'];
  justifyContent?: CSSProperties['justifyContent'];
  flexDirection?: CSSProperties['flexDirection'];
}

export const Row: FC<RowProps> = ({
  children,
  as: Tag = 'div',
  gap = 0,
  gapX,
  gapY,
  alignItems,
  justifyContent,
  flexDirection,
  className,
  style,
  ...rest
}) => {
  const classes = [styles.row, className].filter(Boolean).join(' ');

  const inlineStyle = {
    '--gap-horizontal': `${gapX ?? gap}px`,
    '--gap-vertical': `${gapY ?? gap}px`,
  } as CSSProperties;
  if (alignItems) inlineStyle.alignItems = alignItems;
  if (justifyContent) inlineStyle.justifyContent = justifyContent;
  if (flexDirection) inlineStyle.flexDirection = flexDirection;

  return (
    <Tag className={classes} style={{ ...inlineStyle, ...style }} {...rest}>
      {children}
    </Tag>
  );
};
